import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ReactMarkdown from "react-markdown";
import "./Conditions.css";

const Conditions = ({
  modal,
  toggle,
  basvuruSartlariTitle,
  basvuru_sartlari_aciklama,
}) => {
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      scrollable={true}
      centered={true}
    >
      <ModalHeader toggle={toggle} style={{ color: "#285843" }}>
        {basvuruSartlariTitle}
      </ModalHeader>
      <ModalBody
        style={{
          color: "#285843",
          fontSize: "0.9rem",
          maxHeight: "250px",
          height: "100%",
        }}
      >
        <ReactMarkdown>{basvuru_sartlari_aciklama}</ReactMarkdown>
      </ModalBody>
    </Modal>
  );
};

export default Conditions;
